<script setup lang="ts">
    import LoaderJSON from '@/assets/animations/loader.json';
    import { LOADER_CONFIG } from '@/config.components';
    import { useTemplateRef, onMounted } from 'vue';
    import lottie from 'lottie-web';

    defineProps<{
        progress?: number;
    }>();

    const animationContainer = useTemplateRef('animationContainer');

    onMounted(() => {
        if (animationContainer.value) {
            lottie.loadAnimation({
                container: animationContainer.value,
                animationData: LoaderJSON,
                loop: true,
                autoplay: true,
                renderer: 'svg',
            });
        }
    });
</script>
<template>
    <div
        data-test="loader-background"
        :class="[LOADER_CONFIG.background, 'fixed inset-0 z-50 flex flex-col items-center justify-center']"
    >
        <div
            ref="animationContainer"
            class="h-52 w-52"
        ></div>
        <div
            v-if="progress !== undefined"
            class="pointer-events-none h-6 w-72 rounded border px-0.5 py-0.5"
        >
            <div
                :style="{ width: progress + '%' }"
                data-test="loader-bar-progress"
                class="h-full rounded bg-primary"
            />
        </div>
    </div>
</template>
